export default __webpack_public_path__ + "images/close.svg?7128b7e0e1b5ba7fb0d386f2a4142a86";